import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { getLocale } from '../i18n/index.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('root element not found');

document.documentElement.lang = getLocale();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
